angular.module('ihestiaWidgets.policyOperations', [
  'ui.router',
  'ihestia-widgets-templates-app',
  'ihestiaCommonDirectives.validators',
  'salesPath.outer',
  'lsnBase',
  'ihestiaBase',
  'ihestiaWidgets.policyOperations.common'
  ]);